'use strict';

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Date validation
// DD.MM.YYYY
// Years between 1900 and current year.
_module3.default.directive('dateValidate', function () {
    return {
        require: 'ngModel',
        restrict: 'A',
        scope: {
            params: '<dateValidate'
        },
        link: function link(scope, elem, attr, ngModel) {
            scope.$watch(function () {
                return scope.params.passenger.ArrivalAge;
            }, function () {
                ngModel.$validate();
            });

            ngModel.$validators.date = function (modelValue, viewValue) {
                modelValue = (0, _utils.formatFinnishDateWithLeadingZeros)(modelValue);
                return isValid(modelValue, scope.params);
            };
        }
    };
});

function getDate(day, month, year) {
    return moment(year + '-' + month + '-' + day);
}

function isValidDate(date) {
    return date.isValid();
}

function isPastDate(date) {
    return date <= moment();
}

function isValidAge(passenger, birthDate, departure) {
    if (!departure) {
        // Prevent console errors.
        return false;
    }

    // Check infant, child and adult age
    if (passenger && passenger.ArrivalAge != undefined) {
        var arrivalDate = moment(departure.ArrivalDate2);
        if (arrivalDate) {
            // Adult
            if (passenger.IsAdult || passenger.IsCustomer) {
                // No checks
                return true;
            }

            var age = (0, _utils.ageOn)(arrivalDate, birthDate);

            // Child
            // Must match specified arrival age
            if (passenger.IsChild && age !== passenger.ArrivalAge) {
                return false;
            }

            // Infant
            // Must be under 2 years old
            if (passenger.IsInfant && (age < 0 || age >= 2)) {
                return false;
            }
        }
    }

    // Checks passed
    return true;
}

function isValidYear(year) {
    return year >= 1900 && year <= moment().year();
}

function isValid(value, params) {
    var passenger = params.passenger;
    var departure = params.departure;
    var required = params.required;

    if (!value && !required) {
        return true;
    }

    if (!value) {
        return false;
    }

    if (value && value.indexOf('.') > -1) {
        var numbers = value.split('.');
        var birthDate = getDate(numbers[0], numbers[1], numbers[2]);
        if (numbers.length === 3 && numbers.every(function (number) {
            return !isNaN(number);
        }) // Is number.
        && numbers[0].length === 2 // DD
        && numbers[1].length === 2 // MM
        && numbers[2].length === 4 // YYYY
        && isValidDate(birthDate) && isPastDate(birthDate) && isValidAge(passenger, birthDate, departure) && isValidYear(numbers[2])) return true;
    }

    return false;
}


//////////////////
// WEBPACK FOOTER
// ./src/core/dateValidate.js
// module id = 59
// module chunks = 0 2